import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import type { Entity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

interface UseAsanaMCPProjectsProps {
  connection: IntegrationConnection;
  teamGid?: string;
  options?: Partial<UseQueryOptions<Entity[], Error>>;
}

export function useAsanaMCPProjects({
  connection,
  teamGid,
  options = {},
}: UseAsanaMCPProjectsProps) {
  return useQuery<Entity[], Error>({
    queryKey: ["asana-mcp-projects", connection.id, teamGid],
    queryFn: async () => {
      if (!teamGid) return [];

      const response = await orgAPI.toolbox.execute<Entity[]>({
        integration_connection_id: connection.id,
        action_name: "asana-mcp-get-projects-for-team",
        action_input: { team_gid: teamGid },
      });
      return response.data;
    },
    enabled: !!connection.integration_id && !!teamGid,
    staleTime: 1000 * 60 * 2, // 2 minutes
    ...options,
  });
}
